import React, { useEffect } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import DepartmentManagementColumnModel from './department-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

const DepartmentManagementPage = (): any => {
  // useEffect(() => {
  //   document.title = "Department Management";
  //   },[]);
  useDocumentTitle();
  return (
    <CommonTablePage
      urlInfoKey={urlKey.Department}
      title="Department Management"
      column={DepartmentManagementColumnModel.DepartmentManagementColumn}
    />
  )
}

export default DepartmentManagementPage
